const r = {
  neutral: {
    fg: "var(--neutral)",
    bg: "var(--neutral-bg)",
    border: "var(--neutral-border)"
  },
  accent: {
    fg: "var(--accent-default)",
    bg: "var(--accent-dim)",
    border: "var(--accent-border)"
  },
  success: {
    fg: "var(--success)",
    bg: "var(--success-bg)",
    border: "var(--success-border)"
  },
  warning: {
    fg: "var(--warning)",
    bg: "var(--warning-bg)",
    border: "var(--warning-border)"
  },
  error: {
    fg: "var(--error)",
    bg: "var(--error-bg)",
    border: "var(--error-border)"
  },
  info: {
    fg: "var(--info)",
    bg: "var(--info-bg)",
    border: "var(--info-border)"
  },
  purple: {
    fg: "var(--purple)",
    bg: "var(--purple-bg)",
    border: "var(--purple-border)"
  },
  magenta: {
    fg: "var(--magenta)",
    bg: "var(--magenta-bg)",
    border: "var(--magenta-border)"
  },
  orange: {
    fg: "var(--orange)",
    bg: "var(--orange-bg)",
    border: "var(--orange-border)"
  }
}, a = {
  Waalaxy: {
    fg: "var(--purple)",
    bg: "var(--purple-bg)",
    border: "var(--purple-border)"
  },
  LinkedIn: {
    fg: "var(--info)",
    bg: "var(--info-bg)",
    border: "var(--info-border)"
  },
  Internal: {
    fg: "var(--accent-default)",
    bg: "var(--accent-dim)",
    border: "var(--accent-border)"
  },
  CSV: {
    fg: "var(--warning)",
    bg: "var(--warning-bg)",
    border: "var(--warning-border)"
  },
  Manual: {
    fg: "var(--text-tertiary)",
    bg: "var(--bg-elevated)",
    border: "var(--border-subtle)"
  },
  Unknown: {
    fg: "var(--error)",
    bg: "var(--error-bg)",
    border: "var(--error-border)"
  }
}, e = {
  auto: {
    fg: "var(--success)",
    bg: "var(--success-bg)",
    border: "var(--success-border)",
    label: "pillAuto"
  },
  review: {
    fg: "var(--purple)",
    bg: "var(--purple-bg)",
    border: "var(--purple-border)",
    label: "pillReview"
  }
}, b = {
  active: {
    fg: "var(--success)",
    bg: "var(--success-bg)",
    border: "var(--success-border)",
    dot: "var(--success)",
    icon: "CircleDot",
    label: "statusActive"
  },
  paused: {
    fg: "var(--purple)",
    bg: "var(--purple-bg)",
    border: "var(--purple-border)",
    dot: "var(--purple)",
    icon: "PauseCircle",
    label: "statusPaused"
  },
  error: {
    fg: "var(--error)",
    bg: "var(--error-bg)",
    border: "var(--error-border)",
    dot: "var(--error)",
    icon: "AlertTriangle",
    label: "statusError"
  },
  limited: {
    fg: "var(--warning)",
    bg: "var(--warning-bg)",
    border: "var(--warning-border)",
    dot: "var(--warning)",
    icon: "Timer",
    label: "statusLimited"
  },
  // PROJECT-STATE §4.F.21 — D5 carryover. Transient state shown after the
  // user clicks Reconnect; visually collapses to the accent palette so
  // users see "in progress" without error noise. Composites that need a
  // semantic differentiator from `paused` consume this entry.
  reconnecting: {
    fg: "var(--accent-default)",
    bg: "var(--accent-dim)",
    border: "var(--accent-border)",
    dot: "var(--accent-default)",
    icon: "Loader2",
    label: "statusReconnecting"
  }
}, o = {
  rdv_pris: {
    fg: "var(--accent-default)",
    bg: "var(--accent-dim)",
    border: "var(--accent-border)",
    label: "leadStatusRdvPris"
  },
  rdv_passe: {
    fg: "var(--purple)",
    bg: "var(--purple-bg)",
    border: "var(--purple-border)",
    label: "leadStatusRdvPasse"
  },
  client_pot: {
    fg: "var(--success)",
    bg: "var(--success-bg)",
    border: "var(--success-border)",
    label: "leadStatusClientPot"
  },
  client: {
    fg: "var(--success)",
    bg: "var(--success-bg-strong)",
    border: "var(--success-border-strong)",
    label: "leadStatusClient"
  },
  a_relancer: {
    fg: "var(--warning)",
    bg: "var(--warning-bg)",
    border: "var(--warning-border)",
    label: "leadStatusARelancer"
  },
  perdu: {
    fg: "var(--neutral)",
    bg: "var(--neutral-bg)",
    border: "var(--neutral-border)",
    label: "leadStatusPerdu"
  }
}, g = {
  draft: {
    fg: "var(--neutral)",
    bg: "var(--neutral-bg)",
    border: "var(--neutral-border)",
    label: "campaignStatusDraft"
  },
  active: {
    fg: "var(--success)",
    bg: "var(--success-bg)",
    border: "var(--success-border)",
    label: "campaignStatusActive"
  },
  paused: {
    fg: "var(--warning)",
    bg: "var(--warning-bg)",
    border: "var(--warning-border)",
    label: "campaignStatusPaused"
  },
  paused_auto: {
    fg: "var(--purple)",
    bg: "var(--purple-bg)",
    border: "var(--purple-border)",
    label: "campaignStatusPausedAuto"
  },
  finished: {
    fg: "var(--info)",
    bg: "var(--info-bg)",
    border: "var(--info-border)",
    label: "campaignStatusFinished"
  },
  error: {
    fg: "var(--error)",
    bg: "var(--error-bg)",
    border: "var(--error-border)",
    label: "campaignStatusError"
  }
}, t = {
  cold: {
    fg: "var(--info)",
    bg: "var(--info-bg)",
    border: "var(--info-border)",
    icon: "Snowflake",
    label: "temperatureCold"
  },
  warm: {
    fg: "var(--warning)",
    bg: "var(--warning-bg)",
    border: "var(--warning-border)",
    icon: "Sun",
    label: "temperatureWarm"
  },
  hot: {
    fg: "var(--error)",
    bg: "var(--error-bg)",
    border: "var(--error-border)",
    icon: "Flame",
    label: "temperatureHot"
  }
};
export {
  b as a,
  e as b,
  g as c,
  t as d,
  r as e,
  o as l,
  a as s
};
//# sourceMappingURL=palettes-DoFdaGi8.js.map
